import { render, staticRenderFns } from "./cancelButtonLabel-editor.vue?vue&type=template&id=f3726fd2&scoped=true&"
import script from "./cancelButtonLabel-editor.vue?vue&type=script&lang=js&"
export * from "./cancelButtonLabel-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3726fd2",
  null
  
)

export default component.exports